import React, { useEffect, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl';
import { DateTime } from 'luxon';
import { DATE_FORMAT_SERVER, DATE_MONTHLY, DESENDING_ORDER, FILTER_ALL, LISTING_LIMIT, REGION_MAPPING } from '../../../constants';
import FilterSelect from '../../../components/Filter/FilterSelect';
import DateFilterContainer from './DateFilterContainer';
import { Axios } from '../../../api';
import axios from 'axios';
import ChartContainer from './ChartContainer';
import Loading from '../../../components/Loading';
import TableComponent from '../CandidateListing/Table';
import { customStyles, toCommaSeparated } from '../../../utils';

const VisualizationGraph = ({ appliedFilters }) => {


    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [data, setData] = useState([]);
    const [graphApiData, setGraphApiData] = useState(null);
    const [locationCVcount, setLocationCVcount] = useState({});

    // for table
    let offset = 0;
    const [tableData, setTableData] = useState(false);
    const [loadingOnlyTable, setLoadingOnlyTable] = useState(false);
    const [errorOnlyTable, setErrorOnlyTable] = useState(false);
    const [count, setCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER })

    // For SINGLE range: flatten the nested structure to the old format
    // For MULTI range: data is passed raw to ChartContainer for aggregated bar chart
    const transformData = (currentData = [], previousData = []) => {
        const result = {};

        // Flatten: extract location data from all ranges
        const flatCurrent = currentData.flatMap(rangeItem => rangeItem.data || []);
        const flatPrevious = previousData.flatMap(rangeItem => rangeItem.data || []);

        // Safely combine locations
        const allLocations = new Set([
            ...(flatCurrent || []).map(item => item.location),
            ...(flatPrevious || []).map(item => item.location)
        ]);

        console.log(flatCurrent, flatPrevious, "ALL")

        allLocations.forEach(loc => {
            const currentItem = (flatCurrent || []).find(item => item.location === loc);
            const previousItem = (flatPrevious || []).find(item => item.location === loc);

            result[loc] = {
                current_year: currentItem ? currentItem.trend : [],
                last_year: previousItem ? previousItem.trend : []
            };
        });

        return result;
    };

    const { job, department, dateRanges } = appliedFilters;
    const dateRangesParam = encodeURIComponent(JSON.stringify(dateRanges || []));
    console.log(dateRangesParam, dateRanges)

    const calculateLocationStats = (currentData) => {
        if (!currentData || !Array.isArray(currentData)) {
            return { by_location: {}, overall_total: 0 };
        }

        const location_totals = {};
        let overall_total = 0;

        // Flatten location data from all ranges
        const flatData = currentData.flatMap(rangeItem => rangeItem.data || []);

        flatData.forEach((entry) => {
            const location = entry.location;
            const trend = entry.trend || [];

            // Sum the counts within the trend array
            const total_for_location = trend.reduce((sum, item) => sum + (Number(item.count) || 0), 0);

            location_totals[location] = (location_totals[location] || 0) + total_for_location;
            overall_total += total_for_location;
        });

        return {
            by_location: location_totals,
            overall_total: overall_total
        };
    };

    const getOnlyTableData = async () => {
        setLoadingOnlyTable(true);
        setErrorOnlyTable(false);
        if (count) {
            offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
        } else {
            offset = 0;
        }
        try {
            const result = await Axios.get(`api/careers/candidate/dashboard/page/?offset=${offset}&limit=${LISTING_LIMIT}&is_spontaneous=false&job_ids=${appliedFilters.job?.filter(item => item.value !== 'spontaneous_flag')?.map(item => item.value)?.join(',') || ""}&date_ranges=${dateRangesParam}&department_ids=${department?.value || ""}&locations=${appliedFilters.location?.value || ""}&is_duplicate=${!appliedFilters.removeDuplicates}`, {
                requestId: "api-3"
            })

            setTableData(result.data.payload);
            setCount(result.data.count);
            setLoadingOnlyTable(false)

        } catch (e) {
            if (e.response) {
                setErrorOnlyTable(JSON.stringify(e.response.data.description));
            } else if (axios.isCancel) {

            }
            else {
                setErrorOnlyTable("Network Error");
            }
            setLoadingOnlyTable(false)
        }
    }

    console.log(appliedFilters.job, "jobs")
    const getData = async () => {

        console.log("Fetching data with filters:", appliedFilters);
        setLoading(true);
        setError(false);
        if (count) {
            offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
        } else {
            offset = 0;
        }
        try {
            const tableDataRes = await Axios.get(`api/careers/candidate/dashboard/page/?offset=${offset}&limit=${LISTING_LIMIT}&is_spontaneous=false&job_ids=${appliedFilters.job?.filter(item => item.value !== 'spontaneous_flag')?.map(item => item.value)?.join(',') || ""}&date_ranges=${dateRangesParam}&department_ids=${department?.value || ""}&locations=${appliedFilters.location?.value || ""}&is_duplicate=${!appliedFilters.removeDuplicates}`)
            const graphData = await Axios.get(`api/careers/candidate/dashboard/analysis/?period=${appliedFilters.dateType}&date_ranges=${dateRangesParam}&job_ids=${appliedFilters.job?.filter(item => item.value !== 'spontaneous_flag')?.map(item => item.value)?.join(',') || ""}&department_ids=${appliedFilters.department?.value || ""}&is_duplicate=${!appliedFilters.removeDuplicates}`)
            const graphPayload = graphData?.data?.payload;
            setGraphApiData(graphPayload);
            const finalData = transformData(
                graphPayload?.current_data || [],
                graphPayload?.previous_data || [],

            );

            // This is for location count
            const stats = calculateLocationStats(graphPayload?.current_data || []);
            setLocationCVcount(stats);

            setData(finalData)

            setTableData(tableDataRes?.data?.payload);
            setCount(tableDataRes.data.count);
            // setTableData([]);
            // setCount(0);

            setLoading(false)
        } catch (e) {
            if (e.response) {
                setError(JSON.stringify(e.response.data.description));
            } else if (axios.isCancel) {

            }
            else {
                setError("Network Error");
            }
            setLoading(false)
        } finally {
            console.log("this is funally")
        }
    }



    useEffect(() => {
        getData()
    }, [appliedFilters]);




    return (
        <>
            {
                loading && !error ?
                    <Loading />
                    : !loading && error ?
                        <p className='text-red-500 text-center'>{error}</p>
                        : !loading && !error ?
                            <>
                                <div className="space-y-6 mb-8 mt-10">
                                    <h2 className="heading-sm">CV Statistics Overview</h2>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                        <StatCard
                                            label="Total CVs"
                                            count={locationCVcount?.overall_total || 0}
                                        />
                                        {(!appliedFilters?.location?.value || REGION_MAPPING.US.includes(appliedFilters.location.value)) && (
                                            <StatCard
                                                label="US CVs"
                                                count={REGION_MAPPING.US.reduce((sum, name) => sum + (locationCVcount?.by_location[name] || 0), 0)}
                                            />
                                        )}
                                        {(!appliedFilters?.location?.value || REGION_MAPPING.ITALY.includes(appliedFilters.location.value)) && (
                                            <StatCard
                                                label="Italy CVs"
                                                count={REGION_MAPPING.ITALY.reduce((sum, name) => sum + (locationCVcount?.by_location[name] || 0), 0)}
                                            />
                                        )}
                                    </div>
                                </div>
                                <ChartContainer
                                    appliedFilters={appliedFilters}
                                    data={data}
                                    rawApiData={graphApiData}
                                    isMultiRange={(appliedFilters?.dateRanges?.length || 0) > 1}
                                    getData={getData}
                                />
                                <div>
                                    <div className='flex gap-8 justify-between items-center mt-11 mb-4'>
                                        <h1 className='heading-sm'>Table</h1>

                                    </div>
                                    <TableComponent
                                        data={tableData}
                                        loading={loading}
                                        count={count}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        offset={offset}
                                        getOnlyTableData={getOnlyTableData}
                                        loadingOnlyTable={loadingOnlyTable}
                                        errorOnlyTable={errorOnlyTable}
                                        error={error}
                                    />
                                </div>
                            </>
                            :
                            null
            }

        </>
    )
}

export default VisualizationGraph





const StatCard = ({ label, count }) => (
    <div className="flex flex-col justify-between p-5 rounded-xl border-2 border-primary bg-white shadow-sm hover:shadow-md transition-shadow h-[120px] md:h-[150px]">
        <span className="text-sm md:text-base font-semibold uppercase tracking-wider text-primary/80">
            {label}
        </span>
        <span className="text-3xl md:text-4xl font-black text-primary">
            {count.toLocaleString()}
        </span>
    </div>
);